import Asterisk02Svg from "@redotech/redo-icons/asterisk-02_filled.svg";
import ClockSnoozeSvg from "@redotech/redo-icons/clock-snooze_filled.svg";
import FolderCheckSvg from "@redotech/redo-icons/folder-check_filled.svg";
import StatusSvg from "@redotech/redo-icons/status.svg";
import { ConversationStatus } from "@redotech/redo-model/conversation";
import { formatTimeUntil } from "@redotech/util/date-format";
import { memo, ReactElement } from "react";
import {
  RedoBadge,
  RedoBadgeColor,
  RedoBadgeSize,
} from "../arbiter-components/badge/redo-badge";

const StatusMappings: Record<
  Exclude<ConversationStatus, ConversationStatus.HIDDEN>,
  [RedoBadgeColor, (p: any) => ReactElement]
> = {
  [ConversationStatus.OPEN]: ["success", (p: any) => <Asterisk02Svg />],
  [ConversationStatus.CLOSED]: ["gray", (p: any) => <FolderCheckSvg />],
  [ConversationStatus.SNOOZED]: ["warning", (p: any) => <ClockSnoozeSvg />],
  [ConversationStatus.IN_PROGRESS]: ["blue", (p: any) => <StatusSvg />],
};

/**
 * Arbiter status badge:
 * https://www.figma.com/design/iZHj2I36zd9i8nRbWKw4ZK/%E2%9D%96-Arbiter?node-id=7852-62667&t=TcciBRu2ObN9VJRA-4
 */
export const RedoSupportStatusBadge = memo(function RedoSupportStatusBadge({
  status,
  size = "sm",
  snoozedUntil,
}: {
  status: Exclude<ConversationStatus, ConversationStatus.HIDDEN>;
  size?: RedoBadgeSize;
  snoozedUntil?: string;
}) {
  const [color, iconSvg] = StatusMappings[status];

  /** Put the badge name, and if snoozed, the time until it's over */
  let text = status
    .split("")
    .map((k, i) => (i === 0 ? k.toUpperCase() : k.toLowerCase()))
    .join("");

  if (status === ConversationStatus.SNOOZED && snoozedUntil) {
    text += ` - ${formatTimeUntil(snoozedUntil)}`;
  }

  return (
    <RedoBadge
      color={color}
      segmentLeading={{ type: "icon", Icon: iconSvg }}
      size={size}
      text={text}
      type="primary"
    />
  );
});
